import { createAction, handleActions } from "redux-actions";
import produce from "immer";
import i18n from "../locales/config";

import createRequestThunk from "../lib/createRequestThunk";
import { callEoForSendAction, callEoForSendWhisperAction } from "../lib/EoBrowserSendUtil";

import ConstData from "../lib/ConstData";
import { ctActionType } from "../lib/ConstCommand";
import { ctRcvKind, ctBubbleKind, enTokenCMD, enMQType } from "../lib/classTalk/CodeEnum";
import { checkDownloadableUrl, isNotEmptyStr } from "../lib/func/ExportFunction";

import { upload_file } from "../lib/api/file";

export const WHISPER_STATE_INIT             = "whisper/WHISPER_STATE_INIT";

const WHISPER_INIT                          = "whisper/WHISPER_INIT";

export const CHANGE_W_MEMBER_NICKNAME       = "whisper/CHANGE_W_MEMBER_NICKNAME";

const MQ_SEND_WHISPER_INIT_DATA             = "whisper/MQ_SEND_WHISPER_INIT_DATA";

const APPEND_SEND_MESSAGE                   = "whisper/APPEND_SEND_MESSAGE";
const APPEND_SEND_AUDIO_MEMO                = "whisper/APPEND_SEND_AUDIO_MEMO";
const AUDIO_MEMO_SEND_FAILED                = "whisper/AUDIO_MEMO_SEND_FAILED"; // 20261015 음성메모 전송 실패 표시
const APPEND_SEND_FILE_SHARE                = "whisper/APPEND_SEND_FILE_SHARE";
const APPEND_SEND_FILE_SHARE_SUCCESS        = "whisper/APPEND_SEND_FILE_SHARE_SUCCESS";
const APPEND_SEND_FILE_SHARE_PROGRESS       = "whisper/APPEND_SEND_FILE_SHARE_PROGRESS";
const APPEND_SEND_FILE_SHARE_FROM_HICLASS   = "whisper/APPEND_SEND_FILE_SHARE_FROM_HICLASS";
const APPEND_SEND_CONTENT                   = "whisper/APPEND_SEND_CONTENT";
const UPDATE_CONTENT_SEND_STATUS            = "whisper/UPDATE_CONTENT_SEND_STATUS";

const APPEND_RECEIVE_TEACHER_MESSAGE        = "whisper/APPEND_RECEIVE_TEACHER_MESSAGE";
const APPEND_RECEIVE_STUDENT_MESSAGE        = "whisper/APPEND_RECEIVE_STUDENT_MESSAGE";

const EMOTICON_TOGGLE_OPENED                = "whisper/EMOTICON_TOGGLE_OPENED";
const EMOTICON_SELECTED_CANCEL              = "whisper/EMOTICON_SELECT_CANCEL";
const SELECT_EMOTICON_SEQ                   = "whisper/SELECT_EMOTICON_SEQ";

const ADD_FUNCTION_TOGGLE_OPENED            = "whisper/ADD_FUNCTION_TOGGLE_OPENED";
const SELECT_FUNCTION_SEQ                   = "whisper/SELECT_FUNCTION_SEQ";

const VOICE_MEMO_TOGGLE_CLOSED              = "whisper/VOICE_MEMO_TOGGLE_CLOSED";

const INK_MEMO_TOGGLE_OPENED                = "whisper/INK_MEMO_TOGGLE_OPENED";
const IMG_THUMBNAIL_CLICK                   = "whisper/IMG_THUMBNAIL_CLICK";

const FILE_SHARE_TOGGLE                     = "whisper/FILE_SHARE_TOGGLE";
const FILE_OPEN_TOGGLE                      = "whisper/FILE_OPEN_TOGGLE";
const FILE_SHARE_RESULT                     = "whisper/FILE_SHARE_RESULT";
const FILE_DOWNLOADING                      = "whisper/FILE_DOWNLOADING";

export const whisperPopupInitialize                 = createAction(WHISPER_INIT);

export const mqSendInitData                         = createAction(MQ_SEND_WHISPER_INIT_DATA);

export const appendSendMessage                      = createAction(APPEND_SEND_MESSAGE);
export const appendSendAudioMemo                    = createAction(APPEND_SEND_AUDIO_MEMO);
export const audioMemoSendFailed                    = createAction(AUDIO_MEMO_SEND_FAILED); // 20261015 음성메모 전송 실패 표시

// 20261015 음성메모 전송 실패 표시 - 메시지 식별용 ID 생성
const createAudioMemoId = () => "am" + Date.now().toString() + Math.floor(Math.random() * 100000).toString();

// 20261015 음성메모 전송 실패 표시 - 목록에서 해당 음성메모를 찾아 실패 상태로 변경 (immer draft 대상)
const markAudioMemoSendFailed = (msgList, memoId) => {
    if (!Array.isArray(msgList)) return;

    msgList.forEach(item => {
        const info = item && item.msgInfo;
        if (!info) return;

        if (info.memoId === memoId) {
            info.sendFailed = true;
        }

        // 귓속말 말풍선은 urlInfo 안에 음성메모 정보가 들어있음
        if (info.urlInfo && typeof info.urlInfo === "object" && info.urlInfo.memoId === memoId) {
            info.sendFailed = true;
            info.urlInfo.sendFailed = true;
        }
    });
};
export const appendSendFileShare                    = createAction(APPEND_SEND_FILE_SHARE);
//export const appendSendFileShare                    = createRequestThunk(APPEND_SEND_FILE_SHARE, upload_file);
export const appendSendFileShareProgressAtWhisper   = createAction(APPEND_SEND_FILE_SHARE_PROGRESS);
export const appendSendFileShareFromHiClassAtWhisper = createAction(APPEND_SEND_FILE_SHARE_FROM_HICLASS);
export const appendSendContentAtWhisper             = createAction(APPEND_SEND_CONTENT);
export const updateContentSendStatusAtWhisper       = createAction(UPDATE_CONTENT_SEND_STATUS);
export const appendReceiveTeacherMessage            = createAction(APPEND_RECEIVE_TEACHER_MESSAGE);
export const appendReceiveStudentMessage            = createAction(APPEND_RECEIVE_STUDENT_MESSAGE);

export const emoticonSelectedToggle                 = createAction(EMOTICON_TOGGLE_OPENED);
export const emoticonSelectedCancel                 = createAction(EMOTICON_SELECTED_CANCEL);
export const selectEmoticonSeq                      = createAction(SELECT_EMOTICON_SEQ);

export const addFunctionOpenedToggle                = createAction(ADD_FUNCTION_TOGGLE_OPENED);
export const selectFunctionSeq                      = createAction(SELECT_FUNCTION_SEQ);

// function menu
export const voiceMemoClosedToggle                  = createAction(VOICE_MEMO_TOGGLE_CLOSED);

export const inkMemoOpenedToggle                    = createAction(INK_MEMO_TOGGLE_OPENED);
export const imgThumbnailClick                      = createAction(IMG_THUMBNAIL_CLICK);

export const fileShareToggle                        = createAction(FILE_SHARE_TOGGLE);
export const fileOpenToggle                         = createAction(FILE_OPEN_TOGGLE); 
export const fileShareResult                        = createAction(FILE_SHARE_RESULT); 
export const fileDownloading                        = createAction(FILE_DOWNLOADING);

const initialState = {
    mqSendKey           : "",

    isEmoticonSelected  : false,
    selectedEmoticonSeq : -1,
    selectedFunctionSeq : -1,
    isAudioOpened       : false,
    audioStatus         : "STOPED",
    
    isAddFunctionOpened : false,
    isInkMemoOpened     : false, // ink memo 창

    userInfo            : "",
    stdInfo             : "",

    isProgressBarShow   : false,
    progressCount       : 0,

    whisperMsg          : []
}

const whisper = handleActions({
    [WHISPER_STATE_INIT]: (state, action) => {
        return {
            ...state,
            
            mqSendKey           : "",

            isEmoticonSelected  : false,
            selectedEmoticonSeq : -1,
            selectedFunctionSeq : -1,
            isAudioOpened       : false,
            audioStatus         : "STOPED",
            
            isAddFunctionOpened : false,
            isInkMemoOpened     : false, // ink memo 창

            userInfo            : "",
            stdInfo             : "",

            whisperMsg          : []
        }
    },

    [WHISPER_INIT]: (state, action) => {
        console.log("WHISPER_INIT - ", action.payload);
        const { stdSeq } = action.payload;

        callEoForSendWhisperAction("initDone", stdSeq);

        return {
            ...state,
            stdInfo : {
                stdSeq
            }
        }
    },

    [CHANGE_W_MEMBER_NICKNAME]: (state, action) => {
        console.log("CHANGE_W_MEMBER_NICKNAME - ", action.payload);
        
        const { user_info } = action.payload;
        
        return produce (state, draft => {
            if (user_info.userSeq === Number(draft.stdInfo.stdSeq)) {
                draft.stdInfo.stdNickname = user_info.userNickname;
            }
        });
    },

    [MQ_SEND_WHISPER_INIT_DATA]: (state, action) => {
        console.log("MQ_SEND_WHISPER_INIT_DATA - ", action.payload);
        const { data } = action.payload;

        let stdInfo = {
            ...state.stdInfo,
            stdNickname: data.data.userNickname,
            stdProfileImg: data.data.userProfileImg
        };
        
        return {
            ...state,
            stdInfo,
            userInfo    : data.userInfo,
            whisperMsg  : data.data.chat_history
        }
    },

    [APPEND_SEND_MESSAGE]: (state, action) => {
        const { msgText } = action.payload;
        const { userInfo, stdInfo } = state;
        const { userNickname } = userInfo;
        console.log("APPEND_SEND_MESSAGE - ", action.payload);

        let msgInfo = {
            kind    : ctBubbleKind.SendMsg,
            msgInfo : { 
                rcvKind     : ctRcvKind.Teacher,
                text        : msgText, 
                emoticSeq   : state.selectedEmoticonSeq, 
                urlInfo     : ""
            }
        };

        console.log(msgInfo);

        callEoForSendAction("message_talk", { text: msgText, emoticSeq: state.selectedEmoticonSeq, userNickname }, stdInfo.stdSeq);

        return {
            ...state,
            whisperMsg          : state.whisperMsg.concat(msgInfo),
            isEmoticonSelected  : false,
            selectedEmoticonSeq : -1,
            isAddFunctionOpened : false
        }
    },

    [APPEND_SEND_AUDIO_MEMO]: (state, action) => {
        const { url, data } = action.payload;
        const { userInfo, stdInfo } = state;
        const { userSeq, userNickname } = userInfo;
        console.log("APPEND_SEND_AUDIO_MEMO - ", action.payload);

        // 20261015 전송 실패 시 해당 말풍선에 실패 표시를 하기 위한 ID와 콜백
        const memoId = createAudioMemoId();
        const onFail = () => {
            if (window.hiclasstv && window.hiclasstv.store) {
                window.hiclasstv.store.dispatch(audioMemoSendFailed({ memoId }));
            }
        };

        let msgInfo = {
            kind    : ctBubbleKind.SendMsg,
            msgInfo : { 
                rcvKind : ctRcvKind.Teacher,
                kind    : "audio_memo", 
                text    : i18n.t("음성메모", { ns: "classTalk" }), 
                urlInfo : url,
                memoId  // 20261015 음성메모 식별 ID
            }
        };

        callEoForSendAction("audio_memo", { voiceData:data, userSeq, userNickname, onFail }, stdInfo.stdSeq); // 20261015 onFail 추가

        return {
            ...state,
            whisperMsg          : state.whisperMsg.concat(msgInfo),                    
            isAudioOpened       : false,
            isAddFunctionOpened : false
        }
    },

    // 20261015 음성메모 전송 실패 시 해당 말풍선 실패 표시
    [AUDIO_MEMO_SEND_FAILED]: (state, action) => {
        const { memoId } = action.payload;
        console.log("AUDIO_MEMO_SEND_FAILED - ", memoId);

        return produce(state, draft => {
            markAudioMemoSendFailed(draft.whisperMsg, memoId);
        });
    },

    // whisper Browser에서 [파일공유] 클릭 시, C# 호출
    [APPEND_SEND_FILE_SHARE]: (state, action) => {
        console.log("APPEND_SEND_FILE_SHARE - ", action.payload);
        console.log("whisper 창에서 파일 공유 클릭 시, C# 호출");
        const { mode, chatRoomSeq, teacherSeq, liveSeq, userSeq, userNickname, command, mixedClassStatus, memberSeqList } = action.payload;

        const actionData = {
            mode,
            chatRoomSeq,
            teacherSeq,
            liveSeq,
            userSeq, 
            userNickname,
            command,
            mixedClassStatus,
            memberSeqList
        }

        callEoForSendAction("file_share", actionData);

        return {
            ...state,
            isAddFunctionOpened: false,
        }
    },

    [APPEND_SEND_FILE_SHARE_PROGRESS]: (state, action) => {
        const { data } = action.payload;
        console.log("APPEND_SEND_FILE_SHARE_PROGRESS - ", data, action.payload);

        return {
            ...state,
            isProgressBarShow   : data < 100,
            progressCount       : data
        }
    },

    [APPEND_SEND_FILE_SHARE_FROM_HICLASS]: (state, action) => {
        //const { filename } = action.parms;
        const { filename, isSuccessed } = action.payload;
        const { stdInfo, userInfo } = state;
        const { userNickname } = userInfo;
        console.log("APPEND_SEND_FILE_SHARE_FROM_HICLASS - ", );

        if (isSuccessed) {
            const { isUploadSuccess } = action.payload;
            
            if (isUploadSuccess) {
                const { path } = action.payload;

                let downloadUrl = path;
                if (!checkDownloadableUrl(downloadUrl)) {
                    console.log("/download/ 포함되지 않은 url임 ... downloadUrl path => ", downloadUrl);
                    downloadUrl = ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + path;
                }

                console.log("여기가 귓속말 파일 전송 222");
                callEoForSendAction("whisperFileShare", { filename, path: downloadUrl, userNickname }, stdInfo.stdSeq);

                let msgInfo = {
                    kind : ctBubbleKind.SendMsg,
                    msgInfo : {
                        rcvKind: ctRcvKind.Teacher,
                        kind: "file_share",
                        text: filename + i18n.t("파일_전송_완료_알림", { ns: "classTalk" }),
                        urlInfo: downloadUrl
                    }
                };

                return {
                    ...state,
                    whisperMsg          : state.whisperMsg.concat(msgInfo),
                    isProgressBarShow   : false,
                    progressCount       : 0
                }
            } else {
                console.log("isUploadSuccess is ", isUploadSuccess);

                return {
                    ...state,
                    isProgressBarShow   : false,
                    progressCount       : 0
                }
            }
        } else {
            console.log("isSuccessed is ",isSuccessed);

            return {
                ...state,
                isProgressBarShow   : false,
                progressCount       : 0
            }
        }
    },
    
    [APPEND_SEND_CONTENT]: (state, action) => {
        const { action: contentAction, information, userNickname, receiveStudentSeq } = action.payload;
        console.log("APPEND_SEND_CONTENT - ", action.payload);

        return produce(state, draft => {
            draft.whisperMsg.push({
                kind: ctBubbleKind.SendMsg,
                msgInfo: {
                    rcvKind: ctRcvKind.ContentSend,
                    action: contentAction,    // "url-start" | "app-start" | "file-start" | "message-start"
                    information,              // { url, faviconUrl, contentSeq, contentTeacherSeq, refContentSeq, ... } 원본 구조 그대로
                    userNickname,
                    // receiveStudentSeq: seq 배열 → 상세 객체 배열로 변환해서 저장
                    // 이후 UPDATE_CONTENT_SEND_STATUS에서 각 항목의 status/isReceived 갱신
                    receiveStudentSeq: receiveStudentSeq.map(m => ({
                        userSeq     : String(m.userSeq),
                        userNickname: m.userNickname,
                        isReceived  : false,    // 수신 확인 전
                        status      : null,     // "received" | "executed" | "not_installed" | "downloaded" | "not_support" | "permission_denied" | "invalid_payload"
                    })),
                }
            });
        });
    },
    
    [UPDATE_CONTENT_SEND_STATUS]: (state, action) => {
        const { contentSeq, userSeq, status } = action.payload;
        console.log("UPDATE_CONTENT_SEND_STATUS - payload => ", action.payload);
        // contentSeq: 어떤 전송 건인지 식별
        // userSeq: 누가 수신 확인했는지

        console.log("whisperMsg: ", state.whisperMsg);
        
        return produce(state, draft => {
            // receivedMsg 전체를 순회하며 해당 contentSeq의 말풍선을 찾음
            const targetMsg = draft.whisperMsg.find(
                msg =>
                    msg.kind === ctBubbleKind.SendMsg &&
                    msg.msgInfo.rcvKind === ctRcvKind.ContentSend &&
                    // ✅ APPEND_SEND_CONTENT에서 contentSeq는 information 안에 저장됨
                    // msgInfo.contentSeq (X) → msgInfo.information.contentSeq (O)
                    msg.msgInfo.information?.contentSeq === contentSeq
            );

            if (targetMsg) {
                // receiveStudentSeq 배열에서 해당 학생 항목 갱신
                const member = targetMsg.msgInfo.receiveStudentSeq.find(
                    m => String(m.userSeq) === String(userSeq)
                );

                if (member) {
                    // member.isReceived = status === "received"; // "not_support" 또는 "permission_denied"이면 isReceived = false, "received"이면 isReceived = true
                    member.isReceived = status !== null; // null이면 isReceived = false, 그 외의 경우 isReceived = true ("received" | "executed" | "not_installed" | "downloaded" | "not_support" | "permission_denied" | "invalid_payload")
                    member.status = status;
                    console.log("member status is ", status);
                }
            }
        });
    },

    [APPEND_RECEIVE_TEACHER_MESSAGE]: (state, action) => {
        const { msgInfo } = action.payload;
        console.log("APPEND_RECEIVE_TEACHER_MESSAGE - ", action.payload);

        return {
            ...state,
            whisperMsg : state.whisperMsg.concat({
                kind : ctBubbleKind.SendMsg,
                msgInfo
            })
        }
    }, 

    [APPEND_RECEIVE_STUDENT_MESSAGE]: (state, action) => {
        const { msgInfo } = action.payload;
        console.log("APPEND_RECEIVE_STUDENT_MESSAGE - ", action.payload);

        return {
            ...state,
            whisperMsg : state.whisperMsg.concat({
                kind : ctBubbleKind.RcvWhisper,
                msgInfo
            })
        }
    },

    [EMOTICON_TOGGLE_OPENED]: (state, action) => {
        return {
            ...state,
            isEmoticonSelected  : !state.isEmoticonSelected,
            selectedEmoticonSeq : -1,
            isAddFunctionOpened : false,
        }
    },

    [EMOTICON_SELECTED_CANCEL]: (state, action) => {
        return {
            ...state,
            selectedEmoticonSeq : -1,
            isAddFunctionOpened : false,
        }
    },

    [SELECT_EMOTICON_SEQ]: (state, action) => {
        const selectedEmoticonSeq = action.payload;

        return {
            ...state,
            isEmoticonSelected  : false,
            selectedEmoticonSeq : selectedEmoticonSeq,
            isAddFunctionOpened : false,
        }
    },

    [ADD_FUNCTION_TOGGLE_OPENED]: (state, action) => {
        return {
            ...state,
            isEmoticonSelected      : false,
            selectedEmoticonSeq     : -1,
            isAddFunctionOpened     : !state.isAddFunctionOpened
        }
    },

    [SELECT_FUNCTION_SEQ]: (state, action) => {
        const { func, userSeq, userNickname } = action.payload;
        const { stdInfo } = state;

        let preSelectedFuncSeq = state.selectedFunctionSeq;
        
        if (func === ctActionType.InkMemo) {
            const actionData = {
                userNickname,
                userSeq,
                command     : enTokenCMD.chat_Memo,
                isWhisper   : true,
            }

            callEoForSendAction("memoTalk", actionData, JSON.stringify([{ userSeq: stdInfo.stdSeq, userNickname: stdInfo.stdNickname, profileImgUrl: stdInfo.stdProfileImg }]));
        } 

        return {
            ...state,                
            isEmoticonSelected      : false,
            selectedEmoticonSeq     : -1,
            isAddFunctionOpened     : false,
            isAudioOpened           : func === ctActionType.VoiceMemo,
            selectedFunctionSeq     : preSelectedFuncSeq
        }
    },

    [VOICE_MEMO_TOGGLE_CLOSED]: (state, action) => {
        console.log("close voice memo");
        return {
            ...state,
            isAudioOpened : false
        }
    },

    [INK_MEMO_TOGGLE_OPENED]: (state, action) => {
        const { selectedFunc, userNickname, userSeq } = action.payload;
        const { stdInfo } = state;
        console.log("INK_MEMO_TOGGLE_OPENED : ", selectedFunc);
        
        if(selectedFunc !== undefined && selectedFunc !== null) { // ink memo 말풍선 클릭한 경우
            const { imgUrl } = action.payload;
            const actionData = {
                userNickname,
                userSeq,
                command     : enTokenCMD.chat_Memo,
                inkURL      : imgUrl,
                isWhisper   : true
            }

            callEoForSendAction("inkMemo", actionData, JSON.stringify([{ userSeq: stdInfo.stdSeq, userNickname: stdInfo.stdNickname, profileImgUrl: stdInfo.stdProfileImg }]));

            return {
                ...state
            }
        } else { 
            console.log("이런경우가 있나..?");
            
            return {
                ...state
            }
        }
    },

    [IMG_THUMBNAIL_CLICK]: (state, action) => {
        const { imgDataUrl, idx } = action.payload;
        const { receivedMsg } = state;
        console.log("IMG_THUMBNAIL_CLICK msg idx : ", idx);

        const rcvMsg = receivedMsg[idx];
        if (rcvMsg !== undefined && rcvMsg !== null) {
            console.log("rcvMsg is not null");

            if (rcvMsg.msgInfo !== undefined && rcvMsg.msgInfo !== null) {
                const userSeq = rcvMsg.msgInfo.rcvUserSeq;
                const userNickname = rcvMsg.msgInfo.rcvName;
                console.log("rcvMsg rcvUserSeq => ", userSeq);
                console.log("rcvMsg rcvName => ", userNickname);

                const actionData = {
                    userSeq,
                    userNickname,
                    imgDataUrl
                };

                callEoForSendAction("showImage", actionData);
            }
        }

        return {
            ...state,
        }
    },

    [FILE_SHARE_TOGGLE]: (state, action) => {
        const { fileURL, originalFileName, idx } = action.payload;
        console.log(`FILE_SHARE_TOGGLE - idx[${idx}], fileURL[${fileURL}], originalFileName[${originalFileName}]`);
        const { stdInfo } = state;

        // 20260520 전달받은 원본 파일 이름이 존재하는 경우 그 이름으로 저장되도록 기존 코드 주석 처리 ... by hjkim
        // const filename = fileURL.substr(fileURL.lastIndexOf("/") + 1);
        let filename;
        if (isNotEmptyStr(originalFileName)) {
            filename = originalFileName;
        } else {
            filename = fileURL.substr(fileURL.lastIndexOf("/") + 1);
        }
        console.log("final filename => ", filename);

        const actionData = {
            fileURL,
            filename,
            idx
        };

        callEoForSendAction("fileShare", actionData, stdInfo.stdSeq);

        return {
            ...state,
        }
    },

    [FILE_OPEN_TOGGLE]: (state, action) => {
        const { fileURL, originalFileName, fileType } = action.payload;
        console.log(`FILE_OPEN_TOGGLE - fileType[${fileType}], fileURL[${fileURL}], originalFileName[${originalFileName}]`);
        const { stdInfo } = state;

        // 20260520 전달받은 원본 파일 이름이 존재하는 경우 그 이름으로 저장되도록 기존 코드 주석 처리 ... by hjkim
        // const filename = fileURL.substr(fileURL.lastIndexOf("/") + 1);
        let filename;
        if (isNotEmptyStr(originalFileName)) {
            filename = originalFileName;
        } else {
            filename = fileURL.substr(fileURL.lastIndexOf("/") + 1);
        }
        console.log("final filename => ", filename);

        const actionData = {
            filename,
            fileType
        };

        callEoForSendAction("fileOpen", actionData, stdInfo.stdSeq);

        return {
            ...state,
        }
    },

    [FILE_SHARE_RESULT]: (state, action) => {
        const { idx, memberSeqList } = action.payload;
        console.log("FILE_SHARE_RESULT - ", idx);

        return produce(state, draft => {
            const rcvMsg = draft.whisperMsg[idx];
            if (rcvMsg !== undefined && rcvMsg !== null) {
                if (rcvMsg.msgInfo !== undefined && rcvMsg.msgInfo !== null) {
                    rcvMsg.msgInfo.isDownloading = false;
                    rcvMsg.msgInfo.isDownloaded = true;
                    //rcvMsg.msgInfo.downUrlInfo = fileURL;
                    const fileURL = rcvMsg.msgInfo.urlInfo;

                    const ext = fileURL.substring(fileURL.lastIndexOf("."), fileURL.length);
                    switch (ext) {
                        case ".mp4":
                        case ".wmv":
                            rcvMsg.msgInfo.type = enMQType.Video;
                            break;

                        case ".mp3":
                        case ".wma":
                            rcvMsg.msgInfo.type = enMQType.Audio;
                            break;

                        case ".im3":
                            rcvMsg.msgInfo.type = enMQType.InkMedia;
                            break;

                        default:
                            rcvMsg.msgInfo.type = enMQType.Files;
                            break;
                    }
                    
                    rcvMsg.msgInfo.text = i18n.t("파일_다운로드_완료_알림", { ns: "classTalk" });
                }
            }
        });
    },

    [FILE_DOWNLOADING]: (state, action) => {
        const { idx, progress } = action.payload;
        console.log("FILE_DOWNLOADING");

        return produce(state, draft => {
            const rcvMsg = draft.whisperMsg[idx];
            if (rcvMsg !== undefined && rcvMsg !== null) {
                if (rcvMsg.msgInfo !== undefined && rcvMsg.msgInfo !== null) {
                    rcvMsg.msgInfo.isDownloading = true;
                    rcvMsg.msgInfo.isDownloaded = false;
                    rcvMsg.msgInfo.text = i18n.t("파일_다운로드_중_알림", { ns: "classTalk" });
                    rcvMsg.msgInfo.progress = progress;
                }
            }
        });
    },
}, initialState);

export default whisper;